module.exports = function getResource(label, vars = []) {
    const resources = { title: 'Get It Shipped', freeShip: 'Beauty Insiders enjoy *FREE standard shipping* on all orders.' };
    return resources[label];
};
